'use client'

import { Input } from 'antd'
import { SBDynamicFormInput } from './types'

const SBDynamicFormInputPhone: SBDynamicFormInput = ({ ...rest }) => {
  return <Input {...rest} type="tel" autoComplete="tel" />
}

export { SBDynamicFormInputPhone }
